export function throttle (fn, threshhold, scope) {
  threshhold || (threshhold = 250)
  var last, deferTimer
  return function () {
    var context = scope || this

    var now = +new Date()
    var args = arguments
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer)
      deferTimer = setTimeout(
        function () {
          last = now
          fn.apply(context, args)
        },
        threshhold
      )
    } else {
      last = now
      fn.apply(context, args)
    }
  }
}

export function debounce (func, wait, immediate) {
  var timeout
  return function () {
    let context = this
    let args = arguments
    var later = () => {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    var callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}



// WEBPACK FOOTER //
// ./assets/j/util/tools.js